
<ng-container *ngIf="title">
  <h2 class="pb-3" style="border-bottom: 1px solid #ddd">{{ title }}</h2>
  <p>In questa sezione è&nbsp;possibile consultare e/o scaricare&nbsp;la modulistica cliccando sugli appositi link.</p>
</ng-container>

<div class="it-timeline-wrapper" style="margin-bottom: 3em;">
  <div class="row">

    <div *ngFor="let item of data" class="col-12 element">
      <div class="timeline-element">
        <div class="it-pin-wrapper it-evidence">
          <div class="pin-icon">
            <svg class="icon"><use href="/assets/svg/sprites.svg#it-code-circle"></use></svg>
          </div>
          <div class="pin-text"><span>{{item['createdAt'] | date: 'MMMM y':'':'it-IT'}}</span></div>
        </div>
        <div class="card-wrapper">
          <div class="card">
            <div class="card-body body">
              <div class="category-top">
                <a class="category" href="#">{{ item[type] }} - {{ item.id }}</a>
                <span class="data">{{item['createdAt'] | date: 'dd/MM/yy, h:mm a'}}</span>
              </div>
              <p class="card-text">{{ item.title }}</p>
              <span class="card-signature">{{ item.signature }}</span>
            </div>
          </div>
        </div>
      </div>
    </div>

  </div>
</div>
